export default {
  Nenhum: 0,
  App: 1,
  Web: 2
}
